/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {compose, find, propEq} from 'ramda';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
/**
 * The internal dependencies.
 */
import CheckIcon from '../../../assets/images/temp/ico-checkmark-circle.png';
import TitleIcon from '../../../assets/images/temp/ico-help-dark.png';
import Button from '../../../components/general/button';
import Chevron from '../../../components/general/navigation-chevron';
import CloseButton from '../../../components/task/close-button';
import {workDispatcher, workPlanner, workProductionManager, workQa} from "../../../store/task-view/actions";
import {getTasksCurrent} from "../../../store/tasks/selectors";

const verticallyAligned = `
	display: flex;
	align-items: center;
`;

const Wrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 41.4%;
	height: calc(100% - 41px);
	background: #fff;

	&:after {
		content: '';
		position: absolute;
		right: 1px;
		top: 0;
		height: 100%;
		box-shadow: 3px 0px 6px rgba(0,0,0, 0.5);
		width: 1px;
	}
`;

const TitleBar = styled.div`
	${verticallyAligned}
	justify-content: space-between;
	padding: 13px 22px 70px 48px;
`;

const Title = styled.h5`
	${verticallyAligned}
	font-size: 40px;
	font-weight: 700;
	color: #3b3b3b;

	& img {
		margin-right: 12px;
	}
`;

const Close = styled.span`
	${verticallyAligned}
	font-size: 14px;
	font-weight: 400;
	color: #43abf3;
`;

const ActionsGroup = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
`;

const HelpButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 270px;
	font-size: 19px;
	font-weight: 600;
	border-width: 2px;
	margin: auto;

	& span {
		position: absolute;
		top: 11px;
		left: 15px;
	}

	& + button {
		margin-top: 51px;
	}
`;

const ActionMessage = styled.p`
	${verticallyAligned}

	font-size: 20px;
	padding: 39px 31px 0 27px;

	& img {
		width: 33px;
		height: 33px;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
		border-radius: 50%;
		margin-right: 14px;
	}
`;

const MessageHeaderWrapper = styled.div` 
    ${verticallyAligned}
	justify-content: space-between;
	padding-left: 10px;
	& span {
	    font-size: 20px;
	}
`;

const MessageWrapper = styled.div` 
    ${verticallyAligned}
	justify-content: space-between;
	padding: 12px 12px 50px 12px;

`;

const Message = styled.textarea`
    min-height: 100px;
    width: 100%;
    margin: 0 auto 0 auto;
    padding: 3px; 
`;


class Help extends React.Component {
    constructor() {
        super();

        this.state = {
            selectedAction: null,
            message: '',
            // TODO Refactor
            buttons: [
                // {
                //     id: 'work-planner',
                //     label: 'Arbeitsplaner rufen',
                //     success: 'Arbeitsplaner wurde informiert.',
                // },
                {
                    id: 'production-manager',
                    label: 'Fertigungsleiter rufen',
                    success: 'Fertigungsleiter wurde informiert.',
                },
                // {
                //     id: 'dispatcher',
                //     label: 'Disponent rufen',
                //     success: 'Disponent wurde informiert.',
                // },
                {
                    id: 'qa',
                    label: 'Quali rufen',
                    success: 'Quali wurde informiert.',
                },
            ]
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({message: event.target.value});
    }

    selectAction = (action) => {

        const {currentTask} = this.props;

        switch (action) {
            case 'work-planner':
                this.props.workPlanner();
                break;
            case 'production-manager':
                this.props.workProductionManager(this.state.message, currentTask.id);
                break;
            case 'dispatcher':
                this.props.workDispatcher();
                break;
            case 'qa':
                this.props.workQa(currentTask);
            default :
                break;

        }
        // this.props.workPlanner();
        return this.setState({selectedAction: action});
    };

    render() {
        const {selectedAction, buttons} = this.state;
        const {close} = this.props;
        return (
            <Wrapper>
                <TitleBar>
                    <Title>
                        <img src={TitleIcon}/>

                        <span>Hilfe</span>
                    </Title>

                    <Close>
                        <span>Schließen</span>

                        <CloseButton color="#43abf3" onClick={close}/>
                    </Close>
                </TitleBar>

                <MessageHeaderWrapper>
                    <span>Nachricht:&nbsp;</span>
                </MessageHeaderWrapper>

                <MessageWrapper>
                    <Message value={this.state.message} onChange={this.handleChange}/>
                </MessageWrapper>

                <ActionsGroup>
                    {buttons && buttons.map(button => (
                        <HelpButton
                            key={`help-button-${button.id}`}
                            shadow
                            onClick={() => this.selectAction(button.id)}
                        >
                            {button.label}

                            <Chevron size={12} thickness="2px 2px 0 0"/>
                        </HelpButton>
                    ))}
                </ActionsGroup>

                {selectedAction && (
                    <ActionMessage>
                        <img src={CheckIcon}/>

                        <span>{find(propEq('id', selectedAction))(buttons).success}</span>
                    </ActionMessage>
                )}
            </Wrapper>
        );
    }
}

export default compose(
    connect(
        (state) => ({
            currentTask: getTasksCurrent(state),
        }), {
            workPlanner,
            workDispatcher,
            workProductionManager,
            workQa,
        }
    ),
    withRouter
)(Help);

// export default Help;



// WEBPACK FOOTER //
// ./src/components/task/working/help.js